/**
 * One row per pype across several reads of the same environment, first read wins.
 *
 * A legacy solution is read once per id its streams may carry (see
 * `resolveBotSolutionIds`), and a pype holding streams of both kinds comes back in
 * each read.
 */
export const mergePypesById = <T extends { id?: string | null }>(
  lists: (T[] | undefined)[]
): T[] => {
  const byId = new Map<string, T>();
  const unkeyed: T[] = [];
  lists.flat().forEach((pype) => {
    if (!pype) return;
    if (!pype.id) unkeyed.push(pype);
    else if (!byId.has(pype.id)) byId.set(pype.id, pype);
  });
  return [...byId.values(), ...unkeyed];
};
